import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';

@Component({
    selector: 'accreditation-calendar',
    templateUrl: './accreditation-calendar.component.html',
    styleUrls: ['./accreditation-calendar.component.css'],
    animations: [
        trigger('hideShowAnimator', [
            state('true', style({ opacity: 1 })),
            state('false', style({ opacity: 0 })),
            transition('0 => 1', animate('.5s')),
            transition('1 => 0', animate('.9s'))
        ])
    ]
})

export class AccreditationCalendarComponent implements OnInit {

    accreditationInfo : any  = {};
   
     ngOnInit() {
        let accreditationInfo = {'isFromTabSection' : false}
        this.accreditationInfo = {...{},...accreditationInfo}
    }

    
}
